module.exports = __webpack_public_path__ + "img/IMG_1847.06ffa112.jpg";